import { AppQueryParams } from '@doda/common/src/constants/queryParams';
import { IndustryLResponse } from '@doda/api-client/aspida/@types';
import { cassifyListAsLMS } from '@doda/common/src/utils/convArrayUtil';

/**
 * 業種のAPIリクエスト作成
 * @param queryParams クエリパラメータ
 * @param industries 業種のマスタ
 * @returns 業種のAPIリクエスト
 */
export const createIndustryApiRequest = (
  queryParams: AppQueryParams,
  industries: IndustryLResponse[] | null
) => {
  let industryName = '';
  let requestIndustryLId = '';
  let requestIndustrySId = '';

  const industry = cassifyListAsLMS(queryParams.ind);
  if (industry.lList) {
    // 業種大
    const [lList] = industry.lList;
    const findIndL = industries?.find((indL) => indL.id === lList);
    if (findIndL) {
      industryName = findIndL.name;
      requestIndustryLId = industry.lList.toString();
    } else {
      throw new Error('パラメータの不正(ind)');
    }
  } else if (industry.sList) {
    // 業種小
    const industriesSList = industries?.flatMap(
      (indValue) => indValue.industrySList
    );
    const [sList] = industry.sList;
    const findIndS = industriesSList?.find((indS) => indS.id === sList);
    if (findIndS) {
      industryName = findIndS.name;
      requestIndustrySId = industry.sList.toString();
    } else {
      throw new Error('パラメータの不正(ind)');
    }
  } else {
    throw new Error('パラメータの不正(ind)');
  }

  return { industryName, requestIndustryLId, requestIndustrySId };
};
